<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page two_step_reg">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <span>{{ getTranslations.visitor_forgot_password_3_almost_done_msg }}</span>
          </div>
          <div class="signup-form">
            <form action="">
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsPassword ? '' : 'has-warning' ]">
                <input type="password" class="form-group__textfield"
                       :class="[ !hasErrorsPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_forgot_password_3_enter_password_placeholder_min_6_chars"
                       @keyup="checkPassword" v-model="user.password"/>
                <span v-show="getMessage(messageForPassword) && user.password" class="form-group__feedback">{{ getMessage(messageForPassword) }}</span>
                <!-- <span class="form-group__feedback">{{ getTranslations.visitor_forgot_password_3_warning_msg_at_least_1_digit) }}</span> -->
                <i class="icon-lock"></i>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsConfirmPassword ? '' : 'has-warning' ]">
                <input type="password" class="form-group__textfield"
                       :class="[ !hasErrorsConfirmPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_forgot_password_3_confirm_password_placeholder"
                       @keyup="checkPassword"
                       v-model="user.confirmPassword"/>
                <span v-show="getMessage(messageForConfirmPassword) && user.confirmPassword"
                      class="form-group__feedback">{{ getMessage(messageForConfirmPassword) }}</span>
                <i class="icon-lock"></i>
              </div>
              <div class="form-group form-group--checkbox">
                <input id="remember_me" type="checkbox" value="remember_me_checked" v-model="checkedRememberMe"><label
                for="remember_me">{{ getTranslations.visitor_forgot_password_3_remember_me }}</label>
              </div>
              <input type="submit" :value="getTranslations.visitor_forgot_password_3_reset_password"
                     :class="['btn btn--medium btn--main', ( hasErrorsUsername || hasErrorsPassword || hasErrorsConfirmPassword)? 'deactivated' : '']" @click.prevent="checkButton">
              <!--<div class="form-footer">-->
                <!--{{ getTranslations.visitor_forgot_password_3_sign_up_terms_msg) }}<a>-->
                <!--<router-link to="/terms">{{ getTranslations.visitor_forgot_password_3_terms_and_conditions) }}</router-link>-->
              <!--</a>-->
              <!--</div>-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: '2stepforgotPassword3',
  data() {
    return {
      user: {
        password: '',
        confirmPassword: '',
      },
      messageForPassword: '',
      messageForUsername: '',
      messageForConfirmPassword: '',
      hasErrorsUsername: false,
      hasErrorsPassword: false,
      hasErrorsConfirmPassword: false,
      message: '',
      checkedRememberMe: true,
    };
  },
  methods: {
    ...mapActions('profile', [
      'callForAuthorization',
      'resetPassword',
      'getUserLoginDetails',
    ]),
    getMessage(key) {
      return this.getTranslations[key] || '';
    },
    clearData() {
      this.change();
      this.user.password = '';
      this.user.confirmPassword = '';
      this.messageForPassword = '';
      this.messageForConfirmPassword = '';
      this.hasErrorsPassword = false;
      this.hasErrorsConfirmPassword = false;
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length == max) {
          charCode.preventDefault();
//            return false;
        } else if (value.length > max) {
          // Maximum exceeded
//            this.user.password = this.user.password.substring(0, max);
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    checkPassword(evt) {
      this.messageForUsername = '';
      const min = 6;
      const max = 12;
      // eslint-disable-next-line
      const validPasswordRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
      // https://stackoverflow.com/questions/1559751/regex-to-make-sure-that-the-string-contains-at-least-one-lower-case-char-upper
      const validUsername = this.user.password.match(validPasswordRegex);
      this.hasErrorsPassword = false;

      if (this.user.password.length < min) {
        this.messageForPassword = 'visitor_forgot_password_3_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrorsPassword = true;
      } else if (this.user.password.length > max) {
        this.user.password = this.checkMaxChar(this.user.password, max, evt);
        this.hasErrorsPassword = true;
        this.checkPassword();
      } else if (validUsername !== null) {
        if (this.user.password.length > max) {
          this.user.password = this.checkMaxChar(this.user.password, max, evt);
          this.hasErrorsPassword = true;
        }
        this.messageForPassword = '';
        if (this.user.confirmPassword !== '' && (this.user.confirmPassword === this.user.password)) {
          this.messageForConfirmPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.messageForConfirmPassword = 'visitor_forgot_password_3_entered_passwords_do_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validUsername === null) {
        this.hasErrorsPassword = true;
        // eslint-disable-next-line
        this.messageForPassword = 'visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_';
      }
      if (this.user.password === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.user.confirmPassword === '') {
        this.hasErrorsConfirmPassword = false;
      }
//      if (this.hasErrorsPassword && this.user.password.length >= min) {
//        const passwordWithoutLetter = this.user.password.match(/^(?!.*[A-Za-z]).+$/);
//        const passwordWithoutNumber = this.user.password.match(/^(?!.*\d).+$/);
//        const passwordWithSymbolsExceptUnderscore = this.user.password.match(/^(?!.*\W)_?.+$/);
//        if (passwordWithoutLetter !== null) {
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_does_not_contain_at_least_one_letter;
//        } else if (passwordWithoutNumber !== null) {
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_does_not_contain_at_least_one_1_digit;
//        } else if (passwordWithSymbolsExceptUnderscore === null) {
//          // eslint-disable-next-line
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_;
//        }
//      }
    },
    change() {
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
    },
    checkButton() {
      if (this.hasErrorsPassword || this.hasErrorsConfirmPassword || this.user.password === '' || this.user.confirmPassword === '') {
        this.message = 'visitor_forgot_password_3_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrors = true;
      } else {
        // eslint-disable-next-line
        if (this.hasErrorsPassword === '') {
          this.message = 'User Refreshed the page!! Try again from step1';
          this.hasErrors = true;
        } else {
          const userData = {
            msisdn: this.forgotPasswordInfo,
            password: this.user.confirmPassword,
          };
          this.resetPassword(userData).then(() => {
            const userDataforAuthorization = {
              username: this.forgotPasswordInfo,
              password: this.user.confirmPassword,
              rememberMe: this.checkedRememberMe,
            };
            this.callForAuthorization(userDataforAuthorization).then(() => {
              if (this.getUserAuthorized) {
                this.getUserLoginDetails().then(() => {
                  this.hasErrors = false;
                  this.$router.push('/home');
                });
              } else {
                this.message = 'visitor_forgot_password_3_password_6_char_long';
                this.hasErrors = true;
              }
            });
          });
        }
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'forgotPasswordInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/TwoStepForgotPassword2.vue